module.exports = ".button-bar {\n  margin-bottom: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/locations/details/linear/change-original-linear/dialog-change-original-linear.component.scss
// module id = ./src/app/locations/details/linear/change-original-linear/dialog-change-original-linear.component.scss
// module chunks = main